import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI'

export const useRopInfoStyles = makeStyles(theme => ({
  conversionWrapper: {
    marginTop: 24,
    '@media(max-width: 1300px)': {}
  },
  ropCardsWrapper: {
    border: '1px solid #EAECF0',
    padding: 16
  },
  cardSlide: {
    width: '267px !important'
  },
  progressWrapper: {
    backgroundColor: 'white',
    padding: '16px !important',
    borderRadius: 8
  },
  progress: {
    maxWidth: 872,
    '@media(max-width: 1300px)': {
      flexBasis: 'auto'
    }
  },
  conversion: {
    width: '100%',
    margin: '24px -6px -6px -6px',
    flexBasis: 'auto',
    maxWidth: 'none'
  },
  conversationWrapper: {
    backgroundColor: GRAY_COLORS[50],
    padding: '12px 0',
    borderRadius: 12
  },
  subtitle: {
    fontSize: 14,
    fontWeight: 400,
    color: GRAY_COLORS[500]
  }
}))
